const ua = {
  'nav-bar': {
    'home': 'До дому',
    'about-me': 'Про мене',
    'studying': 'Освіта',
    'contact': 'Комунікація',
  },

  'footer': {
    'footer': 'ІПАМ',
  },
  "home-section-intro": {
    'welcome': 'Радий бачити вас !',
    'welcome-to': 'Вітає',
    'sub-title1': 'React — це бібліотека для створення користувальницьких інтерфейсів. Однією з його відмінних рис є можливість використовувати JSX, мову програмування з синтаксисом, близьким до HTML, який компілюється в JavaScript. Розробники можуть досягти високої продуктивності додатків, як, наприклад, -',
    'sub-title3': '( ! справжній імейл для реєстрації не потрібен - це лиш демонстрація, тож підійде і "123" наприклад). За допомогою React ви можете створювати ізоморфні додатки, які допоможуть вам позбутися неприємної ситуації, коли користувач нетерпляче чекає, поки нарешті закінчиться завантаження даних і на екрані його комп’ютера нарешті з’явиться щось інше, крім анімації завантаження.',
    'sub-title4': 'Створені компоненти можна легко модифікувати та повторно використовувати в нових проектах. Високий відсоток повторного використання коду збільшує охоплення тестуванням, що, у свою чергу, призводить до вищого рівня контролю якості.',
    'main-intro__footer-title1': 'Віртуальний DOM',
    'main-intro__footer-title2': 'Одразу двох зайців',
    'main-intro__footer-title3': 'Перевикористання',
    'main-intro__footer-sub-title1': 'Віртуальний DOM може підвищити продуктивність високонавантажених програм, що може зменшити ймовірність можливих незручностей і покращити взаємодію з користувачем',
    'main-intro__footer-sub-title2': 'Ізоморфний підхід допомагає швидше відтворювати сторінки, тим самим дозволяючи користувачам почуватися комфортніше під час роботи з вашою програмою. Пошукові системи краще індексують такі сторінки.',
    'main-intro__footer-sub-title3': 'Повторне використання коду значно полегшило створення мобільних програм. Якщо ви плануєте використовувати не тільки сайт, але і мобільний додаток, не потрібно наймати дві великі команди розробників.',
  },
  'home-section-galery': {
    'conditions-tooltip-1': 'Сайт з продажу меблів на WordPress, моєю роботою було створення динамічної форми замовлення на JavaScript.',
    'conditions-tooltip-2': 'Верстка макету під всі поширені пристрої',
    'conditions-tooltip-3': 'Верстка макету PixelPerfect',
    'conditions-tooltip-4': 'Бібліотека популярних фільмів на React.js/ redux. Це лиш демонстраційний додаток - тому імейл та пароль при реєстрації вказуйте будь-який (навіть - 123). Проте там багато функцій з сортування, видалення, редагуванням і т.і.',
    'conditions-tooltip-5': 'Магазин популярних фільмів з кошиком та формою замовлення на React.js/ redux. Це лиш демонстраційний додаток - тому імейл та пароль при реєстрації вказуйте будь-який (навіть - 123).',
    'conditions-tooltip-6': 'PixelPerfect верстка з двома темами',
    'conditions-tooltip-7': 'PixelPerfect верстка.',
    'conditions-tooltip-8': 'PixelPerfect верстка для фотографа.',
  },
  'home-section-about': {
    'about': 'Про себе',
    'main-about__description1': 'Два слова про мене. Можливо, трохи суб\'єктивно, завжди важко охарактеризувати себе, але тим не менш... Я позиціоную себе як відповідальну людину. Мені подобається добре/розумне робоче навантаження, коли завжди є чим зайнятися, але це не впливає на баланс між роботою та особистим життям. Мені подобається рухати',
    'main-about__description2': 'квитки до колонок => Виконується => Готово. 80+% усіх завдань є рутинними, і моя робота полягає в тому, щоб їх виконати, це добре. Але справжнє задоволення і пам\'ятний знак я отримую від важких завдань і хитрих багів. Мені подобається працювати в команді з тестувальником, дизайнером, лідером команди та окремим розробником HTML/CSS, але я думаю, що це команда мрії для кожного JS-розробника :)',
    'message-text1': 'Було б чудово працювати над проектами, які використовують технології, які я хотів би вивчити.',
    'message-text2': 'Також буде чудово працювати над проблемами з людьми, які вже мають певний досвід роботи з цими технологіями.',
    'message-text3': 'Я точно хочу створювати додатки для реагування. І звісно розвиватися вище)',
    'main__title-little1': "Комунікативні навички",
    'special-case1': 'Я шукаю компанію, яка працює над продуктом, який мене захоплює. Коли я щодня йду на роботу, я хочу відчувати себе бадьорим і схвильованим.\n' +
      'Я відповідально ставлюся до своїх завдань і мені подобаються погляди Роберта Мартіна на хорошого розробника, як його героя в книзі',
    'special-case2': ' Команда для мене – це не просто колеги з веслування, а справжні друзі, з якими завжди є чим поділитися. Я в захваті від сучасних та динамічних проектів.',
    'main__title-little2': "Практичні навички",
    'main__title-little3': "Галерея",
    'main__title-little4': "Посилання",
  },
  'studying-section' : {
    'intro-title': 'Мій шлях навчання',
    'intro-sub-title': 'Перші кроки',
    'intro-sub-title2': 'Соціальні навички',
    'intro1': 'Спершу я почав вивчати англійську мову та робити перші кроки програмування в Академії ITEA. Потім я пройшов академію ШАГ, а після неї вступив на зовнішні курси EPAM, після чого пройшов у pre-production лабораторію EPAM і після її успішного завершення став front-end розробником з фреймворку REACT на внутрішньому продуктовому проєкті.',
    'intro2': 'У EPAM я працював над величезним проектом для освітньої платформи, де ми розробляли масштабний додаток для студентів і викладачів, заснований на сильно застарілому - працюючому таким додатком, але вимагаючи нового ковтка свіжого повітря з повним редизайном і переписаною логікою роботи. Я займався покращенням існуючого функціоналу, впровадженням нових можливостей та усуненням багів, розбирав складний чужий код і тісно взаємодіяв із командами Backend, QA та дизайнерами. Цей досвід навчив мене мислити широко і глибоко занурюватися в кожну задачу, щоб зробити продукт кращим.',
  },
  'home-section-contact': {
    'title': 'Контакти',
    'title-little': 'Просто передай привіт!',
    'contact-form__input1': 'Ваше ім\'я',
    'contact-form__input2': 'Імейл',
    'contact-form__input3': 'Прізвище',
    'contact-form__input4': 'Телефон',
    'sex-radio-title': 'Опціонально:',
    'radio1': 'Чоловік',
    'radio2': 'Жінка',
    'radio3': 'Інше',
    'conditions': 'Правила та умови',
    'conditions-tooltip': 'Ваші дані з форми будуть надіслані тільки мені, щоб я міг зв\'язатися з вами якомога швидше.',
    'conditions-tooltip-link': 'Політика конфіденційності',
    'submit': 'Надіслати',
    'title-little2': 'Контактна інформація',
    'sub-title': 'Не соромтеся звертатися до нас із будь-якими вашими запитаннями, ми відповімо вам якомога швидше',
    'data-company__item1': 'S.K',
    'data-company__item2': 'Україна',
    'data-company__item3': 'Дніпро',
    'phone': 'Телефон:',
    'email': 'Імейл:',
  },
  'buttons': {
    'english': 'Англійська',
    'ukraine': 'Українська',
  },
};

export default ua;
